import { useEffect, useState } from 'react'

import { menuRecipeFetcherV3 } from '@library/menu-service'
import {
  MenuRecipe,
  MenuRecipeIngredient,
} from '@library/menu-service/queries/menuApiMenuRecipe/types'

const placeholderRecipe = {
  id: 'f2b3dbc6-db36-4990-aa9e-805c07e62bdb',
  nutritional_information: {
    per_100g: {},
    per_portion: {},
  },
  ingredients: [...Array(10)].map((_, index) => ({
    id: index.toString(),
  })) as unknown as MenuRecipeIngredient,
} as unknown as MenuRecipe

export const useFetchRecipe = (
  menuId: string,
  recipeUuid: string,
  numPortions: number,
  deliveryDate: string,
): {
  error: boolean
  loading: boolean
  recipe: MenuRecipe
  reload: () => void
} => {
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)
  const [recipe, setRecipe] = useState({ ...placeholderRecipe, id: recipeUuid })
  const [version, setVersion] = useState(0)

  useEffect(() => {
    if (recipeUuid && menuId && numPortions && deliveryDate) {
      menuRecipeFetcherV3({
        menuId,
        recipeId: recipeUuid,
        numPortions,
        deliveryDate,
      })
        .then((response) => {
          setRecipe(response)
          setError(false)
          setLoading(false)
        })
        .catch(() => {
          setError(true)
          setLoading(false)
        })
    }

    return () => {
      setLoading(true)
      setError(false)
      setRecipe(placeholderRecipe)
    }
  }, [menuId, recipeUuid, numPortions, deliveryDate, version])

  const reload = () => {
    setLoading(true)
    setVersion(version + 1)
  }

  return {
    error,
    loading,
    recipe,
    reload,
  }
}
